if (typeof Preorder !== 'function') {
    class Preorder extends HTMLElement {
        constructor() {
            super();

            this.selectors = {
                checkoutButton: 'shopify-buy-it-now-button',
            }

            this.elements = {
                checkoutButton: document.querySelector(this.selectors.checkoutButton),
            }

            this.classes = {
                hidden: 'hidden'
            }


            this.init();
        }

        init() {
            this.addEventListeners()
        }

        addEventListeners() {
            document.addEventListener(THEME_EVENTS.variantChange, (e) => this.handleVariantChange(e))
        }

        handleVariantChange(e) {
            const variantId = e.detail.variant.id;

            if (e.detail.variant.available === false) {
                this.classList.add(this.classes.hidden);
                return;
            }

            const variant = preorderVariants[variantId];
            const spanDate = this.querySelector('.preorder-date');


            if (variant) {
                if (spanDate && variant.date) {
                    spanDate.textContent = this.getAttribute('data-date-label').replace('[date]', variant.date);
                } else if (spanDate && (variant.date === null || variant.date === undefined || variant.date === '')) {
                    this.classList.add(this.classes.hidden);
                }

                const propertyAddedToCartItemKey = this.getAttribute('data-property-key');
                const propertyAddedToCartItemValue = this.getAttribute('data-property-value').replace('[date]', variant.date);
                const propertyAddedToCartItem = document.querySelector(`input[name="properties[${propertyAddedToCartItemKey}]"]`);


                if (propertyAddedToCartItem) {
                    propertyAddedToCartItem.remove();
                }

                const formId = this.getAttribute('data-form-id');
                const form = formId ? document.getElementById(formId) : null;

                if (variant.preorder === 'true') {

                    if (variant.date !== null && variant.date !== undefined && variant.date !== '') {
                        this.classList.remove(this.classes.hidden);
                    }

                    if (this.elements.checkoutButton) {
                        this.elements.checkoutButton.classList.add(this.classes.hidden)
                    }

                    if (form) {
                        const input = document.createElement('input');
                        
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', `properties[${propertyAddedToCartItemKey}]`);
                        input.setAttribute('value', propertyAddedToCartItemValue);

                        form.appendChild(input);
                    }

                } else {
                    this.resetPreorder();
                }
            }
        }

        resetPreorder() {
            this.classList.add(this.classes.hidden);

            if (this.elements.checkoutButton) {
                this.elements.checkoutButton.classList.remove(this.classes.hidden)
            }
        }
    }
    customElements.define('pre-order', Preorder);
}

